import type { FamilyMember } from '../types/family-planner'

// ─── Planner reference data ──────────────────────────────────
// No sample calendars, events, invitations, or travel deals live here. The
// planner starts empty: real content arrives from the linked providers once the
// backend is deployed, or from what the owner enters by hand (paste box, manual
// events, destinations), which persists locally.

const MS_DAY = 86400000

function startOfWeek(): Date {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  d.setDate(d.getDate() - d.getDay()) // Sunday of the current week
  return d
}

export function ymd(date: Date): string {
  const m = `${date.getMonth() + 1}`.padStart(2, '0')
  const d = `${date.getDate()}`.padStart(2, '0')
  return `${date.getFullYear()}-${m}-${d}`
}

/** Calendar date for weekday `dow` (0=Sun) of week `week` from this week. */
export function dayOf(week: number, dow: number): Date {
  return new Date(startOfWeek().getTime() + (week * 7 + dow) * MS_DAY)
}

/**
 * Who events can be tagged to. Real household members only — this is the one
 * piece of configuration the UI needs before a backend exists; the deployed
 * service will serve it from `/api/planner/members`.
 */
export const MEMBERS: FamilyMember[] = [
  { id: 'nathanael', name: 'Nathanael', color: '#3b82f6' },
  { id: 'meagan', name: 'Meagan', color: '#ec4899' },
]

export const ALL_MEMBER_IDS = MEMBERS.map((m) => m.id)
